// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"AniStickyA_TheComp__kHMWm","show":"AniStickyA_show__WvMmF"};